<template>
  <div class=" ">
    <v-layout row wrap>
      <v-flex>
        <section>
          <v-card
            width="100%"
            height="100%"
            flat
            background-color="#fff"
            class="">
            <v-card-text class="py-0">
              <v-row 
                align="center" 
                style="">
                <v-col 
                  cols="12"
                  md="7">
                  <img
                    :src="require('@/assets/logo/Logo.png')"
                    style="height: calc(100vh - 30px);" />
                </v-col>
                <v-col 
                  cols="12"
                  md="5">
                  <v-card
                    flat
                    class="mr-10">
                    <div>
                      <v-card
                        flat
                        color="#FFFFFFB2"
                        class="border-radius">
                        <v-card-text
                          class="pa-8">
                          <div
                            class="mb-6">
                            <div
                              class="title font-weight-bold black--text mb-2">
                              Masuk Admin Akunting
                            </div>
                          </div>

                          <ValidationObserver 
                            ref="observer">
                            <v-form class="text-left mb-6">
                              <div class="fs-16 label-input mb-1">
                                Email
                              </div>
                              <ValidationProvider 
                                name="Email" 
                                rules="required|email" 
                                v-slot="{ errors }">
                                <v-text-field
                                  v-on:keyup.enter="save"
                                  class="no_box"
                                  outlined
                                  dense
                                  :color="'#080679'"
                                  placeholder="Email"

                                  vv-uppercase

                                  v-model="form.email"
                                  :error-messages="errors"
                                  required>
                                </v-text-field>
                              </ValidationProvider>

                              <div class="fs-16 label-input mb-1">
                                Password
                              </div>
                              <ValidationProvider 
                                name="password" 
                                rules="required|min:5|max:20" 
                                v-slot="{ errors }">
                                <v-text-field
                                  v-on:keyup.enter="save"
                                  class="no_box"
                                  outlined
                                  dense
                                  :color="'#080679'"
                                  placeholder="Password"
                                  :type="show ? 'text' : 'password'"
                                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                  @click:append="show = !show"
                                  :counter="20"

                                  vv-uppercase
                                  
                                  v-model="form.password"
                                  :error-messages="errors"
                                  required>
                                </v-text-field>
                              </ValidationProvider>
                            </v-form>
                          </ValidationObserver>

                          <div 
                            class="text-center mb-6">
                            <div v-if="message.error.length > 0"
                              class="text-center my-4">
                              <div
                                class="error--text d-flex align-start">
                                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                                
                                <span
                                  class="ml-1">
                                  {{ message.error }}
                                </span>
                              </div>
                            </div>

                            <v-btn
                              v-on:keyup.enter="save"
                              :disabled="process.form"
                              :loading="process.form"
                              @click="save"
                              block
                              color="#080679"
                              width="170"
                              height="50"
                              elevation="0"
                              class="title font-weight-bold white--text text-capitalize border-radius">
                              Masuk
                            </v-btn>
                          </div>
                        </v-card-text>
                      </v-card>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data() {
      return {
        show: false,
        form: {
          email: '',
          password: '',
          // device: 'web'
        },
        process: {
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      company () {
        return this.$store.state.company
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+35}, ${g+37}, ${b}, 0.97)`
      }
    },
    mounted () {
      
    },
    methods: {

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.process.form = true

          await post('auth/login', {
            data: this.form
          })
          .then(response => {
            let res = response.data

            if (res.status === 200) {
              console.log(res.results.data)
              let user = res.results.data,
                  // menu_arr = res.results.data.cat_menu_arr.length < 1 ? [] : JSON.parse(res.results.data.cat_menu_arr),
                  menu_default = [
                  // {
                  //   id: 1,
                  //   label: "Dashboard",
                  //   icon: "mdi-view-dashboard",
                  //   link: "/dashboard",
                  //   sub_menu:[]
                  // },
                  // {
                  //   id: 2,
                  //   label: "Hak Akses",
                  //   icon: "mdi-shield-key",
                  //   link: "/category-user",
                  //   sub_menu:[]
                  // },
                  // {
                  //   id: 3,
                  //   label: "Pegawai",
                  //   icon: "mdi-account",
                  //   link: "/user",
                  //   sub_menu:[]
                  // },
                  {
                    id: 4,
                    label: "CoA",
                    icon: "mdi-file-cog",
                    link: "/coa",
                    sub_menu: [
                    // {
                    //     id: 5,
                    //     label: "Aktiva",
                    //     icon: "mdi-file-cog",
                    //     link: "/coa/aktiva",
                    //   },
                    //   {
                    //     id: 6,
                    //     label: "Pasiva",
                    //     icon: "mdi-file-cog",
                    //     link: "/coa/pasiva",
                    //   },
                    //   {
                    //     id: 7,
                    //     label: "Pendapatan",
                    //     icon: "mdi-file-cog",
                    //     link: "/coa/pendapatan",
                    //   },
                    //   {
                    //     id: 8,
                    //     label: "Beban",
                    //     icon: "mdi-file-cog",
                    //     link: "/coa/biaya",
                    //   },
                    ]
                  },
                  {
                    id: 9,
                    label: "Neraca",
                    icon: "mdi-scale-balance",
                    link: "/neraca",
                    sub_menu:[]
                  },
                  {
                    id: 10,
                    label: "Laba Rugi",
                    icon: "mdi-chart-bell-curve-cumulative",
                    link: "/laba-rugi",
                    sub_menu:[]
                  },
                  {
                    id: 11,
                    label: "Jurnal",
                    icon: "mdi-file-document-edit-outline",
                    link: "/jurnal",
                    sub_menu:[]
                  },
                  {
                    id: 12,
                    label: "Buku Besar",
                    icon: "mdi-book-open-blank-variant",
                    link: "/buku-besar",
                    sub_menu:[]
                  },
                  {
                    id: 13,
                    label: "Set Saldo Awal",
                    icon: "mdi-currency-usd",
                    link: "/set-saldo-awal",
                    sub_menu:[]
                  },
                  ]
              
              TokenService.saveToken(
                res.results.token,
                JSON.stringify(user),
                JSON.stringify(menu_default)
              )

              TokenService.saveReload(false)

              TokenService.saveColor(
                '#080679'
              )

              this.$store.commit("setColor", '#080679')

              window.location = `${process.env.BASE_URL}`
              

            } else {
              this.process.form = false
              this.message.error = res.message
            }
          })
        }
      }
    }
  }
</script>